import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ApiService } from 'src/app/api.service';
import { TabService } from 'src/app/utils/TabService';
import { AuthenticationService } from 'src/app/_services';
import { SecurityDocument } from 'src/app/shared/models/SecurityDocument';
import { State } from 'src/app/shared/models/State';
import { CategoryLan } from 'src/app/shared/models/CategoryLan';
import { TranslateRelLabelVO } from 'src/app/shared/models/TranslateRelLabelVO';
import { GuideModel } from 'src/app/shared/models/guide-model';
import { Item } from 'src/app/shared/models/Item';
import { ValuesVO } from 'src/app/shared/models/ValuesVO';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';
import { DatePipe } from '@angular/common';
import { Store } from 'src/app/shared/models/Store';

@Component({
  selector: 'app-purch-itm-dwn-detail',
  templateUrl: './purch-itm-dwn-detail.component.html',
  styleUrls: ['./purch-itm-dwn-detail.component.scss'],
  providers: [MessageService, ConfirmationService, TabService]
})
export class PurchItmDwnDetailComponent implements OnInit {

  //purch item
  listStores: string[] = [];
  listPerson: GuideModel[];
  listGuides: GuideModel[];
  listFutureGuides: GuideModel[];
  selectedGuide: GuideModel;
  listItems: Item[];
  filteredItems: Item[];
  selectedItem: Item;
  listLanguage: ValuesVO[];
  selectedLanguage: ValuesVO;
  purchDate: Date;
  method: string;
  statusPO: string;
  passKey: string;
  currDate: string;
  endDate: Date;
  guideType: string = 'G';


  // CHURCH REGISTER FORM
  churchRegisterForm: FormGroup;
  record: any;
  security: SecurityDocument;
  currentUser: any;
  selLang: string;

  dataParent: any;

  profileUser: any;
  hostLocation: string;
  listState: State[];
  selectedState: State = null;
  lstTypesChurch: CategoryLan[];
  selectedTypeChurch: CategoryLan;

  // LANGUAGE

  lbl_name: string = "name_";
  lbl_email: string = "email_";
  lbl_go_Back: string = "back_";
  lbl_language: string = "language_";
  lbl_select: string = "select_";
  lbl_entry: string = "entry_";
  lbl_guides: string = "guides_";
  lbl_future_guide: string = "future_guide_";
  lbl_item: string = "item_";
  lbl_order_date: string = "order_date_";
  lbl_ending_date: string = "ending_date_";
  lbl_save: string = "save_";
  lbl_delete: string = "delete_record_";
  lbl_approve: string = "approve_";
  lbl_play_audio: string = "play_audio_";
  lbl_grant: string = "grant_";
  lbl_send: string = "send_";
  lbl_are_you_sure: string = "are_you_sure_";


  // SAVE 
  button_save: boolean;
  button_delete: boolean;

  cities: { name: string; code: string; }[];
  selectedCity: { name: string; code: string; };

  selectedZone: Store;
  selectedNatio: Store;
  selectedLocal: Store;

  /**
   * The constructor initializes various services and authenticates the user using a specific method.
   * @param {FormBuilder} formBuilder - A service provided by Angular that helps in building and managing
   * forms in a reactive way.
   * @param {MessageService} messageService - A service that provides methods for displaying messages to
   * the user, such as success messages, error messages, and warning messages.
   * @param {ConfirmationService} confirmationService - The ConfirmationService is a service provided by
   * PrimeNG, a UI component library for Angular. It provides methods for displaying confirmation dialogs
   * to the user, allowing them to confirm or cancel an action.
   * @param {ApiService} apiService - An instance of the ApiService class, which is likely used to make
   * HTTP requests to an API.
   * @param {ActivatedRoute} route - The `route` parameter is an instance of the `ActivatedRoute` class,
   * which is used to retrieve information about the currently activated route. It contains information
   * about the route's parameters, data, and URL segments. It is typically used in Angular applications
   * to retrieve data from the URL and pass it to
   * @param {AuthenticationService} authenticationService - This parameter is an instance of the
   * AuthenticationService class, which is used for handling user authentication and authorization. It is
   * likely used in this code to check if the user is authenticated before allowing access to certain
   * parts of the application.
   * @param {Router} router - The router is a service provided by Angular that allows navigation between
   * different components and views in a single-page application. It is used to navigate to different
   * routes and pass data between components.
   */


  constructor(private formBuilder: FormBuilder, private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private tovpilUtils: TovpilUtilsService,
    private authenticationService: AuthenticationService,
    private router: Router) {
    const navigation = this.router.getCurrentNavigation();
    this.dataParent = navigation.extras.state as any;
    this.currentUser = this.authenticationService.currentUserValue;
  }

  ngOnInit(): void {
    this.churchRegisterForm = this.formBuilder.group({
      "purchDate": new FormControl("", [
        Validators.required
      ]),
      "guide": new FormControl("", [
        Validators.required,
        Validators.maxLength(60),
        Validators.minLength(2),
      ]),
      "language": new FormControl("", [
        Validators.required,
        Validators.maxLength(50),
        Validators.minLength(2),
      ]),
      "type": new FormControl("", [
        Validators.required,
        Validators.maxLength(50),
        Validators.minLength(2),
      ]),
      "guideType": new FormControl("", [
        Validators.required,
        Validators.maxLength(2),
        Validators.minLength(1),
      ]),
      "nameChurch": new FormControl("", [
        Validators.required,
        Validators.maxLength(50),
        Validators.minLength(2),
      ]),
      "endDate": new FormControl("", [
        Validators.required
      ]),
      "streetNumber": new FormControl("", [
        Validators.required,
        Validators.maxLength(50),
        Validators.minLength(2),
      ]),
      "postalCode": new FormControl("", [
        Validators.required,
        Validators.pattern("^[0-9]+"),
        Validators.maxLength(10),
        Validators.minLength(1),
      ]),

      "phoneNumber": new FormControl("", [
        Validators.pattern("^[0-9]+"),
        Validators.maxLength(10),
        Validators.minLength(1),
      ]),
      "comments": new FormControl("", [
        Validators.maxLength(100),
        Validators.minLength(1),
      ]),
    });
    if (this.dataParent) {
      this.listStores = this.dataParent.listStores;


      this.security = this.dataParent.security;
      this.record = this.dataParent.record;
      this.selectedZone = this.dataParent.selectedZone;
      this.selectedNatio = this.dataParent.selectedNatio;
      this.selectedLocal = this.dataParent.selectedLocal;

      if (!this.record) {
        this.method = "CREATE";
        this.statusPO = "N";
      } else {
        this.method = "UPDATE";
        this.loadDataChurch();
      }
      this.listState = this.dataParent.states;
      this.profileUser = this.dataParent.profileUser;
      this.getCategoryById('responsive', 'hostLoc');
      this.getSecurity();



    } else {
    }
  }
  deleteRecord(event) {
    this.confirmationService.confirm({
      message: '¿ '+ this.lbl_are_you_sure +' '+ this.lbl_delete+ ' ?',
      header: this.record.itemDescr + " /" + this.record.guidefullName + " Idioma: " + this.record.purchItmDwn.id.language,
      icon: 'pi pi-exclamation-triangle',
      acceptButtonStyleClass: "p-button-danger",
      rejectButtonStyleClass: "p-button-info",
      accept: () => {
        this.deleteRecordService();
      }
    });
  }
  deleteRecordService() {
    this.apiService.deletePurchItmDwn(this.record.purchItmDwn).then(
      data => {
        this.goBack();
      });

  }
  sendLink(event) {
    this.statusPO = "A";
    this.registerRecord(event);

  }
  registerRecord(event) {

    this.button_save = true;
    this.apiService.getCreateUpdatePurchItmDwn(
      {
        language: this.security.language,
        method: this.method,
        purchItmDwn: {
          id: {
            guideId: this.selectedGuide ? this.selectedGuide.guideId : "",
            itemId: this.selectedItem ? this.selectedItem.itemId : "",
            language: this.selectedLanguage ? this.selectedLanguage.valueId : ""
          },
          passKey: this.passKey,
          purchDate: this.purchDate != null ? this.tovpilUtils.dateToTovpilDate(this.purchDate) : null,
          currDate: this.currDate,
          endDate: this.endDate ? this.tovpilUtils.dateToTovpilDate(this.endDate) : null,
          status: this.statusPO,
        }
      }
    ).then(
      data => {
        if (data && data.status.trim() == 'OK') {
          this.button_save = true;
          this.messageService.add({ severity: 'success', summary: 'Actualizacion', detail: "Se autorizo correctamente", life: 5000 });
          if (this.statusPO == 'A') {
            this.endDate=this.tovpilUtils.convertStringToDate(data.purchItmDwn.endDate);
            //NO BORRAR LA SIGUIENTE LINEA
            //this.sendUrldMessage(data.purchItmDwn.passKey);
          }
          this.goBack();
        } else {

          this.button_save = false;
          this.messageService.add({ severity: 'error', summary: 'ERROR: ' + data.errorMessage, detail: " ", life: 10000 });
        }

      }).catch(error => {
        console.error(error);
        this.messageService.add({ severity: 'error', summary: 'Actualización servicio' + error + "/", detail: "Error al Actualizar servicio" + error + "/", life: 3000 });
      });
  }
  getSecurity() {

    this.apiService.findSecurityById({ "id": this.security.id }).then(
      data => {
        this.security = data;
        if (this.security) {
          this.getGuidesByStore();
          this.getTranslatedLabels();

          this.getLanguages();

          if (this.dataParent.church) {

          } else {


            if (this.listState != null && this.listState.length > 0) {
              this.selectedState = this.listState.find(s => s.id.stateId === this.profileUser.address.state);
            }


          }

        }
      });
  }
  getTranslatedLabels() {
    let map = new Map();
    let lstRespTranslate: TranslateRelLabelVO[];
    this.apiService.listByLanguageMultFields({
      'language': this.security.language,
      'region': this.security.region,
      'lstLabels': [this.lbl_email, this.lbl_go_Back, this.lbl_language, this.lbl_select, this.lbl_name, this.lbl_guides, this.lbl_future_guide, this.lbl_item, this.lbl_order_date, this.lbl_ending_date, this.lbl_save, this.lbl_approve, this.lbl_delete, this.lbl_entry, this.lbl_play_audio,this.lbl_grant,this.lbl_send, this.lbl_are_you_sure
      ]
    }).then(
      trDocs => {
        trDocs.forEach((element) => {
          map.set(element.labelId, element.translation);
        });

        this.lbl_email = map.get(this.lbl_email);
        this.lbl_go_Back = map.get(this.lbl_go_Back);
        this.lbl_language = map.get(this.lbl_language);
        this.lbl_select = map.get(this.lbl_select);
        this.lbl_name = map.get(this.lbl_name);
        this.lbl_entry = map.get(this.lbl_entry);
        this.lbl_play_audio = map.get(this.lbl_play_audio);
        this.lbl_grant=map.get(this.lbl_grant);
        this.lbl_guides = map.get(this.lbl_guides);
        this.lbl_future_guide = map.get(this.lbl_future_guide);
        this.lbl_item = map.get(this.lbl_item);
        this.lbl_order_date = map.get(this.lbl_order_date);
        this.lbl_ending_date = map.get(this.lbl_ending_date);
        this.lbl_save = map.get(this.lbl_save);
        this.lbl_approve = map.get(this.lbl_approve);
        this.lbl_delete = map.get(this.lbl_delete);
        this.lbl_send = map.get(this.lbl_send);
        this.lbl_are_you_sure = map.get(this.lbl_are_you_sure);
      });
  }
  loadDataChurch() {

    this.churchRegisterForm.controls["guide"].setValue(this.record.purchItmDwn.id.guideId);
    this.churchRegisterForm.controls["purchDate"].setValue(this.tovpilUtils.convertStringToDate(this.record.purchItmDwn.purchDate));
    this.churchRegisterForm.controls["endDate"].setValue(this.tovpilUtils.convertStringToDate(this.record.purchItmDwn.endDate));
    this.purchDate = this.tovpilUtils.convertStringToDate(this.record.purchItmDwn.purchDate);
    this.endDate = this.tovpilUtils.convertStringToDate(this.record.purchItmDwn.endDate);
    this.guideType=this.record.guiType;
    this.statusPO = this.record.purchItmDwn.status;
    this.currDate = this.record.purchItmDwn.currDate;
    this.passKey = this.record.purchItmDwn.passKey;

    if (this.statusPO != 'N') {
      this.button_delete = true;
    } else {
      this.button_delete = false;
    }


  }
  goBack() {

    let obj = {
      security: this.security,
      listStores: this.listStores,
      selectedZone: this.selectedZone != null ? this.selectedZone : null,
      selectedNatio: this.selectedNatio != null ? this.selectedNatio : null,
      selectedLocal: this.selectedLocal != null ? this.selectedLocal : null
    }

    let navigationExtras: NavigationExtras = {
      state: JSON.parse(JSON.stringify(obj)),
      queryParams: { token: this.security.id }
    }
    
    this.router.navigate(['materials/purchItmDwnList'], navigationExtras);
  }
  getGuidesByStore() {
    this.apiService.getGuidesByStore({ lstStr: this.listStores }).then(
      data => {
        data = data.map((guide: any) => {
          return {
            ...guide,
            fullName: guide.name + ' ' + guide.lastName
          };
        });
        if (this.record) {
          this.selectedGuide = data.find(s => s.guideId === this.record.purchItmDwn.id.guideId);
        }
        this.listGuides = data.filter(s => s.status === 'A' && s.guiType === 'G');
        this.listFutureGuides = data.filter(s => s.status === 'A' && s.guiType === 'F');
        if (!this.selectedGuide && this.listFutureGuides) {
          this.selectedGuide = this.listFutureGuides[0];
        }
        if (!this.selectedGuide) {
          this.selectedGuide = this.listGuides[0];
        }
        if(this.guideType=='G'){
          this.listPerson = [];
          this.listGuides.forEach(element => {
            this.listPerson.push(element);
          });
        }

        if (!this.guideType || this.guideType && this.guideType=='F') {
          this.listPerson = [];
          this.listFutureGuides.forEach(element => {
            this.listPerson.push(element);
          });         
          this.guideType = "F";          
        }

      });
  }
  listTranslatedItems() {
    this.apiService.listTranslatedItems({ language: this.selectedLanguage.valueId }).then(
      data => {
        this.listItems = data.filter(s => s.itemSts === 'A' && (s.itemCat3 === '12' || s.itemCat3 == '13') && s.sellGUI === true);
        this.filteredItems = data.filter(s => s.itemSts === 'A' && (s.itemCat3 === '12' || s.itemCat3 == '13') && s.sellGUI === true);
        if (this.record) {
          this.selectedItem = data.find(s => s.itemId === this.record.purchItmDwn.id.itemId);
        }
        if (!this.selectedItem) {
          this.selectedItem = this.listItems[0];
        }
      })
      .catch(error => {
        console.error(error);
      });
  }
  getLanguages() {

    const body = {
      storeId: this.security.storeId,
      language: this.security.language
    }
    this.apiService.getListSpkLangByStoreId(body).then(
      data => {
        this.listLanguage = data;

        if (this.record) {
          this.selectedLanguage = this.listLanguage.find(s => s.valueId === this.record.purchItmDwn.id.language);
        } else {

          this.selectedLanguage = this.listLanguage.find(l => l.valueId === this.security.language);
        }
        this.listTranslatedItems();
      });
  }
  sendUrldMessage(passKey: string) {
    let dateStr = new DatePipe('en-US');
    this.apiService.sendMessages([{
      "subject": "Downloads " + this.selectedItem.descri,
      "language": this.security.language,
      "title01": "Downloads",
      "title02": this.record.guidefullName,
      "title03": "",
      "paragraph01": "<p>Usted ha sido autorizado para reproducir el audio correspondiente en este correo</p>"
      +"<p>Vigencia del: " + dateStr.transform(this.purchDate, 'dd-MM-yyyy') + " al " + dateStr.transform(this.endDate, 'dd-MM-yyyy') + "</p>",
      "freeText01": "<p>Ingrese a https://santov.tovpil.org con sus credenciales creadas o asignadas </p>" 
      +"<p>una vez ingresado puede acceder a la opción de descargas  </p>",
      "freeText02": "",
      "senderName": "",
      "emailtoReply": "",

      "listEmails": [this.record.guideEmail],
      "lstFiles": []
    }])

      .then(
        response => {

        }
      )
  }
  getCategoryById(fieldId: string, fieldVal: string) {
    this.apiService.getCategoryById({
      "fieldId": fieldId,
      "fieldVal": fieldVal
    }).then(
      response => {
        if (fieldId == 'responsive') {
          this.hostLocation = response.descrip;
        }

      }
    )
  }
  changeListGuides(event) {
    this.listPerson = []
    console.log(this.guideType);
    if (this.guideType == "F") {
      this.listFutureGuides.forEach(element => {
        this.listPerson.push(element);
      });
      this.filteredItems = this.listItems.filter(s => s.itemSts === 'A' && (s.itemCat3 === '12' || s.itemCat3 == '13') && s.sellFG === true);
    } else {
      this.listGuides.forEach(element => {
        this.listPerson.push(element);
      });
      this.filteredItems = this.listItems.filter(s => s.itemSts === 'A' && (s.itemCat3 === '12' || s.itemCat3 == '13') && s.sellGUI === true);
    }
    this.selectedGuide = {}
    this.selectedGuide = this.listPerson[0];
  }
}
